import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Label, Button } from 'reactstrap'
import { MdCameraAlt } from 'react-icons/md'
import { changeTeilnahmedatum } from '../store/punkteMeldung/actions';
import { BasisPunkte } from './TeilnehmerMelden/AddTeilnehmer/BasisPunkte';
import { LernerfolgPunkte } from './TeilnehmerMelden/AddTeilnehmer/LernerfolgPunkte';
import { CSS_CLASSNAME_PANEL } from '../EIVCommons';
import  ReferentenPunkteComponent  from './TeilnehmerMelden/AddTeilnehmer/RefPunkteComponent';
import AbweichendesTeilnahmedatum from './AbweichendesTeilnahmedatum';

import moment from 'moment';
import { getMinDate, getMaxDate, isShowTeilnahmedatum } from './TeilnehmerMelden/teilnahmedatum';
import { parseListe, uebernehmbareEFNs } from '../store/punkteMeldung/listenEingabe';
import ListenEingabe from './TeilnehmerMelden/ListenEingabe';

import QRCodeScannerDialog from './QRCodeScannerDialog';

const AddTeilnehmer = (props) => {
	const { veranstaltung, mehrereEFNs, teilnahmedatum, changeTeilnahmedatum } = props;
	const vnr = veranstaltung.vnr;
	const minDate = getMinDate(veranstaltung)
	const maxDate = getMaxDate(veranstaltung)
	const showTeilnahmedatum = isShowTeilnahmedatum(veranstaltung);

	const [showScanDialog, setShowScanDialog] = useState(false);

	return(
		<div className={"container " + CSS_CLASSNAME_PANEL}>
			{ showTeilnahmedatum &&
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-xl-6  p-2 ">
					<div className="input-group">
						<Label className="col-form-label">Teilnahmedatum:</Label>&nbsp;
						<AbweichendesTeilnahmedatum minDate={minDate} maxDate={maxDate} onChange={changeTeilnahmedatum} startDate={teilnahmedatum}></AbweichendesTeilnahmedatum>
					</div>
				</div>
			</div>
			}
			<div className="row justify-content-between">
				<div className="col-sm-6 col-lg-4 col-xl-3 p-2 ">
					<BasisPunkte vnr={vnr} punkte={veranstaltung.punkte_basis}/>
				</div>

			{ veranstaltung.punkte_lernerfolg > 0 && !mehrereEFNs &&
				<div className="col-sm-6 col-lg-4 col-xl-3 p-2">
					<LernerfolgPunkte vnr={vnr} punkte={veranstaltung.punkte_lernerfolg}/>
				</div>
			}
			<div className="col col-sm-12 col-md-6 col-lg-4 col-xl-4 p-2">
				{ !mehrereEFNs &&
				<div>
					{/* Ausgeschrieben, weil viele Veranstalter zwar wissen, dass die
					    wissenschaftliche Leitung einen Punkt bekommt, aber nicht, dass er hier
					    als Referentenpunkt eingetragen wird. Die Aufzaehlung der Rollen ist die
					    Wiedererkennung - ohne sie wuerden sie an anderer Stelle danach suchen.
					    Label bewusst ueber dem Steuerelement: ausgeschrieben passt es in dieser
					    schmalen Spalte nie in eine Zeile. */}
					<Label className="d-block mb-1 py-0" title="Kategorie (F) Punkte für Referent, Moderator, Wiss. Leitung">
						<span className="d-lg-none">Ref/Mod/WL Pkte.</span>
						<span className="d-none d-lg-inline">Punkte für Referent, Moderation, wiss. Leitung</span>
					</Label>
					<ReferentenPunkteComponent vnr={vnr}></ReferentenPunkteComponent>
				</div>
				}
				
			</div>
			</div>
			<div className="row">
			{/* Bootstrap 5 setzt jedes direkte Kind von .row auf width:100% - ohne
			    Spaltenklasse rutscht der Knopf in eine eigene Zeile.
			    Auf dem Telefon ein voller Block wie das Eingabefeld und der Hinzufuegen-Knopf
			    darunter (die stehen dort per .listen-eingabe-gruppe ohnehin auf voller Breite) -
			    ein schmalerer Knopf daneben war die einzige abweichende Kante in dieser Spalte.
			    Ab sm wieder nur so breit wie noetig, dort steht er neben dem Feld. */}
			<span className='col-12 col-sm-auto p-2 d-grid d-sm-block'>
				<Button title="Scan EFN Barcode" color="secondary" outline
					onClick={ (e) => { setShowScanDialog(true); }}>
					<MdCameraAlt fontSize="1.5em" aria-hidden="true" ></MdCameraAlt>
					<span className="d-sm-none ms-2">EFN Barcode scannen</span>
				</Button>
			</span>
			{/* Ausserhalb der Knopfspalte: der Dialog ist ein Modal und gehoert nicht ins Raster. */}
			<QRCodeScannerDialog isOpen={showScanDialog} veranstaltung={veranstaltung}
				toggle={() => setShowScanDialog(!showScanDialog)}
				hideDialog={() => setShowScanDialog(false)} />
			<div className="col-sm-10 p-2">
				<ListenEingabe veranstaltung={veranstaltung} />
			</div>
			</div>
			{props.children}
		</div>
	)
}

const mapStateToProps = (state, ownProps) => {
	const eingabe = state.punkteMeldung.addTeilnahme[ownProps.veranstaltung.vnr].efn;
	// Gezaehlt werden verschiedene EFNs aus den *uebernehmbaren* Zeilen. Eine EFN in einer
	// stehenbleibenden Zeile darf der einen tatsaechlich uebernommenen nicht die Lernerfolg-
	// und Referentenpunkte wegnehmen.
	return {
		mehrereEFNs: uebernehmbareEFNs(parseListe(eingabe).zeilen).length > 1,
		teilnahmedatum: state.punkteMeldung.addTeilnahme[ownProps.veranstaltung.vnr].teilnahmedatum
	}
}

const mapDispatchToProp = (dispatch, ownProps) => ({
	changeTeilnahmedatum:  (teilnahmedatum) => {
		if(!teilnahmedatum) teilnahmedatum = moment(ownProps.veranstaltung.beginn).toDate()
		const minDate = getMinDate(ownProps.veranstaltung)
		return dispatch(changeTeilnahmedatum(ownProps.veranstaltung.vnr, teilnahmedatum===null?minDate:moment(teilnahmedatum.getTime()).endOf('day').valueOf()))
	}
})
export default connect(mapStateToProps, mapDispatchToProp)(AddTeilnehmer)
